import React from "react";
import moment from "moment";
import ReferralModal from "../modals/ReferralModal";
import { useTranslation } from "react-i18next";

const ReferralData = (props) => {
  const { i18n, t } = useTranslation(["consultations"]);
  return (
    <React.Fragment>
      {props.showReferralModal && (
        <ReferralModal
          onClose={props.toggleReferralModal}
          userToken={props.userToken}
          consultationId={props.consultationId}
          referralId={props.attachments[0].content.id}
        />
      )}
      <div style={{ display: "flex" }}>
        <div
          data-tooltip={t("viewPharmacyDetailsToolTip")}
          style={{ margin: "0 1rem 1rem 0", padding: "1rem" }}
        >
          <i
            className="fas fa-clinic-medical e2e-view-pharmacy-details"
            style={{ cursor: "pointer", fontSize: "20px" }}
            onClick={() => props.toggleReferralModal(props.referralModalName)}
          ></i>
        </div>

        <div style={{ fontSize: "1.3rem" }}>
          <p> {props.message}</p>
          <p>
            {moment(props.created_at).locale(i18n.language).format("HH:mm")}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReferralData;
